export enum Applications {
    DispatchApp = 1,
    TripApp = 2,
    ReceptionApp = 3,
}